import React from 'react';
import './newsindex.scss'


const NewsItemFull = ({img, title, subtitle, copy}) => {
	return <article className="component newsitem --full">
				{ img && 
					<header>
						<img src={ img } alt={ title }/>
					</header>
				}
				<div>
					{ title && <h1>{ title }</h1>}
					{ subtitle && <h2>{ subtitle }</h2>}
					{ copy && <span className="copy" dangerouslySetInnerHTML={{__html : copy}}/>}
				</div>
			</article>
}


const NewsItemTeaser = ({img, thumb, title, subtitle, handleClick}) => {
	return <article className="component newsitem --teaser" onClick={()=>{ handleClick() }}>
				<header>
					<img src={ thumb || img } alt={ title }/>
				</header>
				<div>
					{ title && <h1>{ title }</h1> }
					{ subtitle && <h2>{ subtitle.length > 140 ? subtitle.substring(0,137) + '...' : subtitle }</h2> }
				</div>
			</article>
}


const NewsIndex = ({data}) => {
	
	const showArticle = (i) => {
		let article = <NewsItemFull {...data[i]}/>
		window.dispatchEvent(new CustomEvent('Component.Overlay.Open', {detail: {content : article}}))
	}

	return 	<section className="component newsindex">
				<div className="inner">
					<h1>Recent Stories</h1>
					<div className="items">
						{data.map((item, i) => {
							return <NewsItemTeaser key={i} {...item} handleClick={()=>{ showArticle(i) }}/>
						})}
					</div>
				</div>
			</section>
}

export default NewsIndex;


// WEBPACK FOOTER //
// ./src/blocks/newsindex/newsindex.jsx